import React, { useState, useEffect, useContext } from "react";
import {
  Masthead,
  MastheadMain,
  MastheadToggle,
  MastheadBrand,
  MastheadContent,
  PageToggleButton,
  Toolbar,
  ToolbarContent,
  ToolbarGroup,
  ToolbarItem,
  Button,
  ButtonVariant
} from "@patternfly/react-core";
import { LINKS } from "shared/config/links";
import FolderIcon
  from "@patternfly/react-icons/dist/esm/icons/folder-icon";
import { Appearance } from "shared/appearance";
import GithubIcon from "@patternfly/react-icons/dist/esm/icons/github-icon";
import ProfileButton from "shared/components/ProfileButton";

import { Link } from "react-router-dom";

import { EducationContext } from "shared/context/EducationContext";
import { AppContext } from "shared/context/AppContext";
import { AuthContext } from "shared/context/AuthContext";
import { withRouter } from "shared/utils/withRouter";

import OrganizationNav from "./Header/OrganizationNav";
import { UserDropdown } from "shared/components/User";
import BrandSvg from "./Header/BrandSvg";

function DashboardHeader(props) {
  const app = useContext(AppContext);
  const auth = useContext(AuthContext);
  const education = useContext(EducationContext);
  const api_url = app.state.react_app_api_url;
  const organizationSymbol = app.state.organizationSymbol;
   
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768
  );
  const userProfile = props.context.state.userProfile || {};


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Masthead>
      <MastheadMain>
        <MastheadToggle>
          <PageToggleButton
            isHamburgerButton
            aria-label="Toggle sidebar"
            variant="plain"
            style={{
              textDecoration: "none",
              marginRight: "10px",
            }}
          />
        </MastheadToggle>

        <MastheadBrand>
          <Link
            to={`/${organizationSymbol}`}
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                marginTop: '2px',
                display: "flex",
                alignItems: "center",
                marginLeft: isMobile ? "0px" : "-15px",
              }}
            >
              <BrandSvg name={organizationSymbol.toUpperCase()} />
            </div>
          </Link>
        </MastheadBrand>
      </MastheadMain>

      <MastheadContent>
        <Toolbar isFullHeight isStatic>
          <ToolbarContent>
            <ToolbarGroup>
              <ToolbarItem>
                <OrganizationNav
                    state={{
                        ...props.state,
                        ...education.state,
                        api_url
                    }}
                    location={props.location}
                />
              </ToolbarItem>
            </ToolbarGroup>

            <ToolbarGroup
              align={{ default: "alignEnd" }}
            >
              {props.context.state.isAuthUser && (
                <ToolbarItem>
                  <Button
                    component={Link}
                    to="/files"
                    variant={ButtonVariant.stateful}
                    state="read"
                    icon={<FolderIcon />}
                    aria-current={
                      props.location?.pathname?.startsWith(
                        "/files",
                      )
                        ? "page"
                        : undefined
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    Pliki
                  </Button>
                </ToolbarItem>
              )}
              {userProfile.is_superuser && (
                <ToolbarItem
                  style={{ marginRight: "12px" }}
                >
                  <Button
                    variant={ButtonVariant.plain}
                    onClick={() =>
                      window.open(
                        LINKS.GITHUB,
                        "_blank"
                      )
                    }
                    aria-label="Open GitHub"
                  >
                    <GithubIcon
                      style={{
                        fontSize: "24px",
                        marginBottom: "-4px",
                      }}
                    />
                  </Button>
                </ToolbarItem>
              )}

              <ToolbarItem
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Appearance />
              </ToolbarItem>

              {props.context.state.isAuthUser &&
              props.context.state
                .isLoadedUserProfile ? (
                <ToolbarItem>
                  <UserDropdown
                    userProfile={userProfile}
                    systemInfo={auth.state.systemInfo}
                    isAuth={
                      props.context.state
                        .isAuthUser
                    }
                    logout={auth.logout}
                    openAdmin={() =>
                      window.open(
                        `${api_url}/admin/`,
                        "_blank"
                      )
                    }
                  />
                </ToolbarItem>
              ) : (
                <ToolbarItem>
                  <ProfileButton
                    loginUrl={`/${organizationSymbol}/ti/auth`}
                  />
                </ToolbarItem>
              )}
            </ToolbarGroup>
          </ToolbarContent>
        </Toolbar>
      </MastheadContent>
    </Masthead>
  );
}

export default withRouter(DashboardHeader);

